import { useCallback } from "react";
import { AgentDetailSaveScope } from "../../../agentDetail.model";
import { useAgentsStore } from "../../../store/agents.store";
import {
    selectAgentDetailSaving,
    selectHasErrorsByScope,
    selectIsScopeDirty,
} from "../../../store/agentDetail/agentDetailSelectors";

export const useAgentDetailSave = (scope: AgentDetailSaveScope = "all") => {
    const isDirty = useAgentsStore(selectIsScopeDirty(scope));
    const hasErrors = useAgentsStore(selectHasErrorsByScope(scope));
    const isSaving = useAgentsStore(selectAgentDetailSaving);
    const saveAgentDetail = useAgentsStore((state) => state.saveAgentDetail);
    const canSave = isDirty && !isSaving && !hasErrors;

    const save = useCallback(async (): Promise<boolean> => {
        const state = useAgentsStore.getState();
        const isCurrentlyDirty = selectIsScopeDirty(scope)(state);
        if (!isCurrentlyDirty) return true;
        if (selectHasErrorsByScope(scope)(state)) return false;
        return saveAgentDetail(scope);
    }, [saveAgentDetail, scope]);

    return { save, isSaving, isDirty, hasErrors, canSave };
};
